import usePowerCycle from "../../hooks/usePowerCycle";

/**
 * Renderless component that drives power cycle phase transitions
 * for a device on the list view. It runs the usePowerCycle hook
 * which watches device.status and device.power_state and updates
 * the Redux phase accordingly.
 */
const DeviceCycleTracker = ({ serialNumber, device }) => {
  usePowerCycle(serialNumber, device);
  return null;
};

export default DeviceCycleTracker;
